/** Повідомлення service worker вікну кабінету: перейти за адресою натиснутого push-сповіщення */
export const NOTIFICATION_CLICK_MESSAGE = 'NOTIFICATION_CLICK'

/**
 * Відкрите вікно кабінету водія (/driver, /driver/…), у якому показати натиснуте сповіщення; інші
 * вікна того ж сайту (адмінка) не підходять — у них немає обробника переходу.
 */
export const findDriverCabinet = <T extends { url: string }>(clients: readonly T[]): T | undefined =>
    clients.find((client) => {
        const path = new URL(client.url).pathname
        return path === '/driver' || path.startsWith('/driver/')
    })
